import { UploadItemCard } from '@app/modules/social-export/publish';
import { CompositionSocialUploadItemDto } from '@app/modules/compose/composition.types';
import { useComposition } from '../../hooks/useComposition';
import { useComposeSocialExportUploadItemCardActions } from './useComposeSocialExportUploadItemCardActions';

interface ComposeSocialExportUploadItemCardProps {
  upload: CompositionSocialUploadItemDto;
}

/**
 * Composition social upload card: delegates layout to shared social-export card.
 */
export function ComposeSocialExportUploadItemCard({
  upload,
}: ComposeSocialExportUploadItemCardProps) {
  const { composition } = useComposition();
  const { trigger: actionsTrigger, menuAndDialog: actionsMenuAndDialog } =
    useComposeSocialExportUploadItemCardActions({ compositionId: composition.id, upload });

  return (
    <UploadItemCard
      upload={upload}
      actionsTrigger={actionsTrigger}
      actionsMenuAndDialog={actionsMenuAndDialog}
    />
  );
}
